<template>
    <div class="aboutLong">
        <ul class="lists">
            <li v-for="(n,i) in navLists" :key="i" v-bind:class='{ lists_active: about_index == i}'
                @click="getAboutInfo(i)">{{n}}
            </li>
        </ul>
        <div class="aboutContent" v-html="htmlDecode(aboutContent.replace(/\/public/g, this.weburl +'/public'))"></div>
    </div>
</template>

<script>
export default {
  name: "aboutLong",
  inject: ["showMsg"],
  data: function() {
    return {
      navLists: [],
      about_index: 0,
      aboutContent: ""
    };
  },
  created: function() {
    this.getAboutInfo(0);
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[3]");
  },
  methods: {
    getAboutInfo: function(i) {
      this.about_index = i;
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/Other/getAbout",
        dataType: "json",
        data: {
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            for (let i = 0; i < res.data.result.length; i++) {
              this.navLists.push(res.data.result[i].name);
            }
            this.aboutContent = res.data.result[i].content;
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    //计算属性，
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/nav";

.lists {
  margin-bottom: 20px;
}

.lists_active {
  color: @brick_red;
  &:after {
    background: @brick_red;
  }
}

.aboutContent {
  width: 95%;
  margin: auto;
  min-height: 395px;
  @media (max-width: 360px) {
    min-height: 357px;
  }
  @media (max-width: 320px) {
    min-height: 282px;
  }
}

.aboutLong {
  .media;
}
</style>
<style scoped>
.aboutContent >>> img {
  width: 100%;
}

.aboutContent >>> span {
  font-size: 16px !important;
}

.aboutContent >>> h1 > span {
  font-size: 26px !important;
}
</style>
